import * as Styled from './styled';
import { Props } from './types';

function Title({ children, ...props }: Props) {
  return <Styled.Title {...props}>{children}</Styled.Title>;
}

export default Title;
